import * as Sentry from '@sentry/browser';
import createSentryMiddleware from 'redux-sentry-middleware';

import { AUTH, UPGRADE, SUCCESS, FAILED } from '../config/routes';

import { sentrySensitiveProps } from './sentrySensitiveProps';
import { sentryIgnoreList } from './ignoreList';

export default function initSentry(SENTRY_DSN, SENTRY_RELEASE, SENTRY_ENVIRONMENT) {
  if (process.env.ENV === 'test') return;

  if (!SENTRY_DSN) {
    console.warn('MONITORING: Missing SENTRY_DSN. Errors will not be sent to Sentry.');
    return;
  }

  const isFatal = isCriticalPath(window.location.pathname);
  Sentry.configureScope(scope => {
    scope.setLevel(isFatal ? Sentry.Severity.Fatal : Sentry.Severity.Error);
  });

  Sentry.init({
    dsn: SENTRY_DSN,
    release: SENTRY_RELEASE,
    environment: SENTRY_ENVIRONMENT
  });
}

export function initSentryMiddleware() {
  return createSentryMiddleware(Sentry, {
    actionTransformer: action => {
      let reduxAction = { ...action };
      sentrySensitiveProps.forEach(name => {
        if (action.hasOwnProperty(name)) reduxAction = null;
      });
      return reduxAction;
    }
  });
}

export function sendErrorToSentry(err) {
  if ((err.httpStatusCode && err.httpStatusCode < 500) || sentryIgnoreList.indexOf(err?.err) >= 0) return; // if `err` is from a Http Request only log `server errors`

  let error = err;

  if (!(error instanceof Error)) {
    error = err?.err && err.err instanceof String ? new Error(err?.err) : new Error(JSON.stringify(err));
  }

  Sentry.captureException(error);
}

export function sendAsMessageToSentry(msg, severityLevel = 'info') {
  Sentry.captureMessage(msg, severityLevel);
}

export function setSeverityLevel(history) {
  history.listen(({ pathname }) => {
    const isFatal = isCriticalPath(pathname);
    Sentry.configureScope(scope => {
      scope.setLevel(isFatal ? Sentry.Severity.Fatal : Sentry.Severity.Error);
    });
  });
}

export function setUserContext({ userId }) {
  Sentry.setUser({ id: userId });
}

function isCriticalPath(pathname) {
  const criticalPaths = new RegExp(`(${AUTH}|${UPGRADE}|${SUCCESS}|${FAILED})`);
  return criticalPaths.test(pathname);
}
